import React from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import { SpaceShape } from 'venuescanner-js/react/shapes';
import ShortlistButton from '../ShortlistButton';
import Carousel from './Carousel';
import CarouselAdmin from './CarouselAdmin';
import WouldBookAgain from './stats/WouldBookAgain';
import Pricing from './stats/Pricing';
import Capacity from './stats/Capacity';
import ResponseTime from './stats/ResponseTime';
import SpaceLink from './SpaceLink';

const showVenueType = false;
const VenueType = ({ name }) => <span className='venue-type'>{name}</span>;
export default class Space extends React.Component {
  constructor(props) {
    super(props);
    this.state = { contactDisplay: '' };
  }

  static propTypes = {
    space: SpaceShape.isRequired,
    ga: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool.isRequired, // TODO: Put in top level store, don't pass through
    superLoggedIn: PropTypes.bool, // TODO: Put in top level store, don't pass through
    isSelected: PropTypes.bool,
    small: PropTypes.bool,
    isReducedSpace: PropTypes.bool,
    noShortlist: PropTypes.bool,
    includeSrpFilters: PropTypes.bool,
  };

  static defaultProps = {
    isSelected: false,
    small: false,
    isReducedSpace: false,
    noShortlist: false,
    includeSrpFilters: false,
  };

  render() {
    const {
      space,
      ga,
      isAdmin,
      superLoggedIn = false,
      isSelected,
      small,
      isReducedSpace,
      noShortlist,
      includeSrpFilters,
      ...otherProps
    } = this.props;
    const { id, oid, lat, lng, hasFlag, venueId } = space;
    const { postcode, city } = space;
    let postcodeFirst = postcode.replace(/\d\D+$/, '');
    if (postcodeFirst.match(/^[a-z]*$/i)) {
      postcodeFirst = postcode.replace(/\D+$/, '');
    }
    const fullName = `${space.venue_name}, ${space.name}`;
    return (
      <div
        itemScope={true}
        itemType='http://schema.org/EventVenue'
        className={cl('space-tile', {
          'selected-on-map': isSelected,
          'space-tile-mobile': small,
          'space-tile__reduced': isReducedSpace,
        })}
        data-id={id || oid}
        data-lat={lat}
        data-lng={lng}
        hasflag={hasFlag}
        data-venue-id={venueId}
        {...otherProps}>
        {(isAdmin || superLoggedIn) && !noShortlist && (
          <CarouselAdmin space={space} />
        )}
        <div className='space-tile__image'>
          {showVenueType && space.venue_type && (
            <VenueType name={space.venue_type} />
          )}
          <Carousel
            space={space}
            ga={ga}
            includeSrpFilters={includeSrpFilters}
          />
        </div>
        <div className={cl('space-tile__flag', space.classes)}></div>
        <SpaceLink
          isAdmin={isAdmin}
          superLoggedIn={superLoggedIn}
          space={space}
          ga={ga}
          className='space-tile__details'
          includeSrpFilters={includeSrpFilters}>
          <div className='title'>
            <h4 className='space-tile__title' itemProp='name'>
              {fullName}
            </h4>
            <p className='space-tile__address' itemProp='address'>
              {[city, postcodeFirst.toUpperCase()].join(' - ')}
            </p>
            <p className='space-tile__description' itemProp='description'>
              {space.description}
            </p>
            <div className='space-tile__review'>
              <Capacity space={space} />
              <WouldBookAgain space={space} />
              <ResponseTime space={space} />
            </div>
          </div>
          <Pricing space={space} />
          {isReducedSpace && (
            <div className='space-tile__reduced__contact'>
              {space?.contact_info?.phone && (
                <span
                  className='space-tile__reduced__contact--item space-tile__reduced__contact--phone'
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({
                      contactDisplay: (
                        <a href={`tel:${space.contact_info.phone}`}>
                          {space.contact_info.phone}
                        </a>
                      ),
                    });
                  }}></span>
              )}
              {space?.contact_info?.email && (
                <span
                  className='space-tile__reduced__contact--item space-tile__reduced__contact--email'
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({
                      contactDisplay: (
                        <a
                          href={`mailto:${space.contact_info.email}`}
                          target='_blank'>
                          {space.contact_info.email}
                        </a>
                      ),
                    });
                  }}></span>
              )}
              {space?.contact_info?.website && (
                <span
                  className='space-tile__reduced__contact--item space-tile__reduced__contact--web'
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({
                      contactDisplay: (
                        <a
                          href={
                            space.contact_info.website.match(/^http/)
                              ? space.contact_info.website
                              : `https://${space.contact_info.website}`
                          }
                          target='_blank'>
                          {space.contact_info.website.replace(
                            /^http.*\/\//,
                            '',
                          )}
                        </a>
                      ),
                    });
                  }}></span>
              )}
              <div className='space-tile__reduced__contact__display'>
                {this.state.contactDisplay}
              </div>
            </div>
          )}
        </SpaceLink>
        {!noShortlist && (
          <ShortlistButton space={space} isReducedSpace={isReducedSpace} />
        )}
      </div>
    );
  }
}
